// tslint:disable:object-literal-sort-keys
const messages = {
  app: {
    unhandledErrorException: 'Something went wrong. Please try to log out and login again.',
  },
  auth: {
    error: 'You are not authorized to view this page',
  },
  navigation: {
    orders: 'Orders',
    searchOrders: 'Search Orders',
  },
  orders: {
    columns: {
      fileNumber: 'File number',
      borrowers: 'Borrowers/Buyers',
      address: 'Property address',
      countyName: 'County',
      externalStatus: 'Status',
      lenderName: 'Lender',
      loanNumber: 'Loan ID',
      externalPartyTransactionId: 'Transaction ID',
      closesOn: 'Closing Date',
    },
  },
};

export default messages;
